import { makeRequest } from "../http-common";

const NoteDataService = {
    // for canned notes
    set_active_codes() {
        return [
            { id: 0, label: "Inactive" },
            { id: 1, label: "Active" },
          ];
      },

    canned_categories: () => ["policies"],

    
    getAllbyRef: async function(ref) {
        return makeRequest('get', `/note/${ref}/related`);
    },

    getCanned: async function() {
        return makeRequest('get', '/note/canned');
    },

    getCannedById: async function(id) {
        return makeRequest('get', `/note/canned/${id}`);
    },
    
    createCanned: async function(data) {
        return makeRequest('post', '/note/canned', data);
    },

    updateCanned: async function(id, data) {
        return makeRequest('put', `/note/canned/${id}`, data);
    },
    
    create: async function(data) {
        return makeRequest('post', '/note', data);
    },

    update: async function(id, data) {
        return makeRequest('put', `/note/${id}`, data);
    },

    delete: async function(id) {
        return makeRequest('delete', `/note/${id}`);
    }
};

export default NoteDataService;